// extracted by mini-css-extract-plugin
export default {"textAreaField":"UpsertProjectModal_textAreaField__OLiJM"};